import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const SourceEmbeddingSchema = z.object({
  sourceEmbeddingId: PrimaryKeySchema,
  sourceId: PrimaryKeySchema,
  sourceTitleDescriptionHash: z.string(),
  model: z.string(),
  embedding: z.array(z.number()),
  createdAt: z.coerce.date(),
});

export type SourceEmbedding = z.infer<typeof SourceEmbeddingSchema>;

export const SourceEmbeddingsSchema = z.array(SourceEmbeddingSchema);

export type SourceEmbeddings = z.infer<typeof SourceEmbeddingsSchema>;

export const SourceEmbeddingsFiltersSchema = z
  .object({
    sourceEmbeddingIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    sourceIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    collectionIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type SourceEmbeddingsFilters = z.infer<
  typeof SourceEmbeddingsFiltersSchema
>;

export const SourceEmbeddingSearchOptionsSchema = z.object({
  query: z.string(),
  limit: z.number().optional(),
  collectionIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
});

export type SourceEmbeddingSearchOptions = z.infer<
  typeof SourceEmbeddingSearchOptionsSchema
>;

export const SourceEmbeddingSearchResultSchema = z.object({
  sourceEmbeddingId: PrimaryKeySchema,
  score: z.number(),
});

export type SourceEmbeddingSearchResult = z.infer<
  typeof SourceEmbeddingSearchResultSchema
>;
